// extracted by mini-css-extract-plugin
export default {"errorPage":"styles_errorPage__852bj","col":"styles_col__gD3N0","code":"styles_code__MVYYS","message":"styles_message__l1Fwn"};